import type Store from '@ember-data/store'
import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type { IntlService } from 'ember-intl'
import type SchoolSubscription from 'teacher-ui-client/models/school-subscription'

export default class ManageRolloverWizardRoute extends Route {
  @service store!: Store

  @service intl!: IntlService

  model() {
    const { subscriptionType } = this.modelFor('subscription-type') as ModelForSubscriptionTypeRoute
    const schoolSubscriptions = this.store.peekAll<SchoolSubscription>('school-subscription').filter((schoolSub) => {
      const isCurrentSubscription = schoolSub.subscriptionType === subscriptionType
      return isCurrentSubscription && !schoolSub.isExpired
    })
    return { schoolSubscriptions, subscriptionType }
  }

  buildRouteInfoMetadata() {
    return { title: this.intl.t('manage.rollover.title') }
  }
}
